import PropTypes from 'prop-types';
import Modal from 'components/Modal';
import React from 'react';

import Button from 'components/Button';
import { DeleteOutlineIcon } from 'utils/icons';

import './styles.scss';

const DeleteConfirmModal = ({
  confirmText,
  itemName,
  description,
  onConfirm,
  onCancel,
  showModal,
  handleOnClose,
  confirmLabel,
  disabled,
  ...rest
}) => {
  const handleConfirm = () => {
    typeof onConfirm === 'function' && onConfirm();
  };

  const handleCancel = () => {
    typeof onCancel === 'function' && onCancel();
  };

  return (
    <Modal
      show={showModal}
      onHide={handleOnClose}
      className="delete-confirm-modal"
      size="sm"
      centered={true}
      {...rest}
    >
      <div className="delete-confirm-modal-body-wrapper">
        <div className="delete-confirm-modal-body-wrapper__image-container">
          <DeleteOutlineIcon className="delete-confirm-modal-body-wrapper__image-container__icon" />
        </div>
        <div className="main-title delete-confirm-modal-body-wrapper__title">
          {confirmText}
        </div>
        <div className="delete-confirm-modal-body-wrapper__text">
          {itemName}
        </div>
        {description && (
          <p className="delete-confirm-modal-body-wrapper__description">
            {description}
          </p>
        )}
        <div className="action-wrapper d-flex flex-justify-center">
          <Button
            label="Cancel"
            className="button-wrapper__cancel-btn"
            onClick={handleCancel}
            variant="grey-outlined"
          />
          <Button
            label={confirmLabel}
            className="button-wrapper__confirm-btn"
            onClick={handleConfirm}
            variant="danger"
            isDisabled={disabled}
          />
        </div>
      </div>
    </Modal>
  );
};

DeleteConfirmModal.propTypes = {
  confirmText: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
  itemName: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
  description: PropTypes.node,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  handleOnClose: PropTypes.func.isRequired,
  confirmLabel: PropTypes.string,
  disabled: PropTypes.bool,
};

DeleteConfirmModal.defaultProps = {
  description: null,
  confirmLabel: 'Delete',
  disabled: false,
};

export default DeleteConfirmModal;
